// import Coins from '@/views/coins/coins'
// import Earn from '@/views/coins/earn'

const ActivityCenter = r => require.ensure([], () => r(require('@/views/activityCenter/activityCenter')), '@/views/coins/..')

const GoldCoinMall = r => require.ensure([], () => r(require('@/views/coins/GoldCoinMall')), '@/views/coins/..')

export default [
    {
        path: '',
        component: ActivityCenter,
        meta: {
            title: '活动中心'
        }
    },
   
  
]



// WEBPACK FOOTER //
// ./src/router/activityCenter.js